import Router from "./router";
import AppointmentsService from "./appointments-service.js";
import ViewMessage from "./view-message.js";

export default class PageRouter extends Router {
  #isReload;
  #firstLoad = true;
  #ui;

  init() {
    this.#cacheUiElements();
    super.init(this.#ui.body);
    this.#bindEvents();
  }

  async load(url, data = {}, http_method = "GET") {
    try {
      await super.load(url, data, http_method);
    } catch (error) {
      const vm = new ViewMessage({
        type: "alert",
        header: "Error",
        body: "There was an error loading the page, please reload the page try again. If this problem persists please contact the practice to report the issue."
      });
      vm.display();

      // Unexpected errors should propagate.
      throw error;
    }
  }

  #cacheUiElements() {
    this.#ui = {
      body: $("body"),
      navbar: $("#main-navbar"),
      navbarNav: $("#navbar-nav"),
      footerAttr: $("footer .attribution")
    };
  }

  #bindEvents() {
    this.#ui.body.on("content-loaded", async (e, { url }) => {
      // Ignore propagated routing events, we only care about 
      // full page navigation events directly triggered on the body.
      if (e.target != this.#ui.body[0]) {
        return;
      }

      // Consume the event so if there is more than one router
      // (e.g., in a modal) they don't both fire.
      e.stopPropagation();

      this.#updateNavigationHistory(url);
      await this.refreshNavbar();
      this.#refreshFooter();
      this.refreshIntercepts();
    });

    $(window).on("popstate", async (e) => {
      if (e.originalEvent.state) {
        const url = e.originalEvent.state;
        this.#isReload = true;
        this.load(url);
      }
    });
  }

  #updateNavigationHistory(url) {
    // Ignore the login/out flow when updating the navigation history
    const pathLower = url.pathname.toLowerCase();
    if (pathLower == "/account/loginsuccess"
      || pathLower == "/account/logoff"
      || pathLower == "/account/resetpasswordconfirmation") {
      return;
    }

    // this.page is used for refreshing and returnUrls
    // so it should be set after the account login flow
    // so we don't have login return url's directing
    // back to the login page again.
    this.page = url.pathname;

    if (this.#firstLoad) {
      history.replaceState(url.toString(), "", url);
      this.#firstLoad = false;
      return
    }

    if (!this.#isReload) {
      history.pushState(url.toString(), "", url);
    }

    this.#isReload = false;
  }

  async refreshNavbar() {
    try {
      const params = new URLSearchParams(window.location.search);
      let returnUrl = params.get("ReturnUrl") ?? this.page;
      // Don't redirect to login flow pages
      if (returnUrl.toLowerCase().startsWith("/account/")) {
        returnUrl = "/";
      }
      const content = await AppointmentsService.getNavbarNav(returnUrl);
      this.#ui.navbarNav.html(content);

      this.refreshIntercepts();
    } catch (errResp) {
      // Log any error response and continue
      console.error(errResp);
    }
  }

  #refreshFooter() {
    if ($("img.needs-attribution").length > 0) {
      this.#ui.footerAttr.removeClass("hidden");
    }
    else {
      this.#ui.footerAttr.addClass("hidden");
    }
  }

  refreshIntercepts() {
    super.refreshIntercepts();
    this.#interceptSubmit();
  }

  async refreshPage() {
    try {
      this.#isReload = true;
      await this.load(this.page);
    } catch (errResp) {
      console.error(errResp);
      alert("There was an error loading the page content, please reload the page and try again.");
    }
  }

  #interceptSubmit() {
    // Intercept form submission (includes the navbar logout form)
    let $forms = this.#ui.body.find("form");
    $forms.off("submit").on("submit", async (e) => {
      e.preventDefault();

      const $form = $(e.currentTarget);
      await this.load($form.attr("action"), $form.serializeObject(), "POST")
    });
  }
}